<template>
  <div class="filters">
    <fieldset class="radio-filters">
      <legend class="select-label">Lajittele:</legend>
      <label for="sort-1"><input type="radio" id="sort-1" :value="false" v-model="reverseOrder"> Mielipiteitä jakavimmat</label>
      <label for="sort-2"><input type="radio" id="sort-2" :value="true" v-model="reverseOrder"> Yhtenäisimmät mielipiteet</label>
    </fieldset>
  </div>
  <div class="questions-wrapper">
    <div v-for="id in filteredQuestions" :key="id" class="question">
      <LikertChart :data="questions ? questions.get(id) : null" :title="questionNames[id][lang]" />
    </div>
    <button class="yddviz-button" v-if="limit < questionIds.length" @click="limit += 3">Näytä lisää</button>
  </div>
</template>

<script>
import loadData from '../utils.js'
import LikertChart from '../components/LikertChart.vue'

import regions from '../data/hva_meta.json'
import questionNames from '../data/questions.json'

export default {
  name: 'CompareParties',
  components: {
    LikertChart,
  },
  props: {
    loadData: Function,
  },
  data() {
    return {
      regions,
      questions: null,
      questionNames,
      limit: 3,
      reverseOrder: false,
    }
  },
  created() {
    loadData('all').then((response) => {
      this.questions = response;
    });
  },
  watch: {
  },
  computed: {
    questionIds() {
      return ['q3', 'q13', 'q16', 'q29', 'q9', 'q10', 'q15', 'q35', 'q23', 'q19', 'q33', 'q8', 'q17', 'q24', 'q32', 'q2', 'q14', 'q7', 'q26', 'q27', 'q34', 'q31', 'q22', 'q28', 'q6', 'q21', 'q1'];
    },
    filteredQuestions() {
      let questions = this.questionIds.slice();
      if (this.reverseOrder) {
        questions.reverse();
      }
      return questions.slice(0, this.limit);
    },
  },
  methods: {
  },
}
</script>
